import { FormControl, Grid, InputLabel, MenuItem, OutlinedInput, Select, TextField } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../contexts/auth";
import { FormLayout } from "../../../layouts/form";
import { NotificationManager } from "react-notifications";
import { CompaniesService } from "../../../services/companies";
import { DriversService } from "../../../services/drivers";
import "./styles.css";
import moment from "moment-timezone";

export const DriverForm = ({ onClose, defaultValues }) => {
    const companiesService = new CompaniesService();
    const driversService = new DriversService();

    const [companies, setCompanies] = useState([]);
    const [saving, setSaving] = useState(false);

    const { userType, userCompanyId } = useContext(AuthContext);

    const [selectedCompanyId, setSelectedCompanyId] = useState();

    const handleChange = (event) => {
        setSelectedCompanyId(event.target.value);
    }

    useEffect(() => {
        if (userType !== 'SystemAdmin') {
            companiesService.getCompany(userCompanyId).then(res => {
                const companiesList = [res.data];
                setCompanies(companiesList);
            }).catch(error => {
                console.error(error);
            });
        } else {
            companiesService.getCompanies().then(res => {
                setCompanies(res.data);
            }).catch(error => {
                console.error(error);
            });
        }

        setSelectedCompanyId(userCompanyId);
    }, []);

    const validateFields = (fields) => {
        const f = fields;

        if (f.name === "" ||
            f.model === "" ||
            f.temperatureIntThreshold === "" ||
            f.humidityThreshold === "" ||
            f.cO2Threshold === "" ||
            f.vibrationThreshold === "") {
            return false;
        } else {
            return true;
        }
    }

    const handleCreationSuccess = () => {
        NotificationManager.success('Motorista criado com sucesso.', "", 3000);
        setSaving(false);
        onClose();
    }

    const handleUpdateSuccess = () => {
        NotificationManager.success('Motorista atualizado com sucesso.', "", 3000);
        setSaving(false);
        onClose();
    }

    const handleDriverSave = (formData) => {
        const data = new FormData(formData);

        if (defaultValues) {
            const updatedDriver = {
                "id": defaultValues.id,
                "name": data.get('name'),
                "cpf": data.get('cpf'),
                "cnhNumber": data.get('cnhNumber'),
                "rfidTagValue": data.get('rfidTagValue'),
                "cnhExpirationDate": data.get('cnhExpirationDate'),
                "companyId": data.get('companyId'),
            };
            if (!validateFields(updatedDriver)) {
                setSaving(false);
                return;
            }

            setSaving(true);
            driversService.updateDriver(updatedDriver).then((res) => {
                handleUpdateSuccess();
            }).catch((err) => {
                NotificationManager.warning('RFID já cadastrado.', "", 3000);
                setSaving(false);
            });

        }
        else {
            const newDriver = {
                "name": data.get('name'),
                "cpf": data.get('cpf'),
                "cnhNumber": data.get('cnhNumber'),
                "rfidTagValue": data.get('rfidTagValue'),
                "cnhExpirationDate": data.get('cnhExpirationDate'),
                "companyId": data.get('companyId'),
            };

            if (!validateFields(newDriver)) {
                setSaving(false);
                return;
            }

            setSaving(true);

            driversService.createDriver(newDriver).then((res) => {
                handleCreationSuccess();
            }).catch((err) => {
                NotificationManager.warning('RFID já cadastrado.', "", 3000);
                setSaving(false);
            });
        }
    }

    const styleBorderField = (width) => {
        return ({
            boxShadow: '1px 1px 3px 1px rgb(217, 217, 217)',
            borderRadius: '6px',
            width: width,
        });
    }

    return (
        <FormLayout onSaveClick={handleDriverSave} saving={saving} disableButton={saving}>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <TextField
                        id="name"
                        fullWidth
                        required
                        label="Nome"
                        name="name"
                        variant="outlined"
                        defaultValue={defaultValues ? defaultValues.name : ""}
                        sx={styleBorderField("100%")}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        id="cpf"
                        fullWidth
                        required
                        label="CPF"
                        name="cpf"
                        variant="outlined"
                        defaultValue={defaultValues ? defaultValues.cpf : ""}
                        sx={styleBorderField("100%")}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        id="cnhNumber"
                        fullWidth
                        required
                        label="CNH"
                        name="cnhNumber"
                        variant="outlined"
                        defaultValue={defaultValues ? defaultValues.cnhNumber : ""}
                        sx={styleBorderField("100%")}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="company-select-id-label">Empresa</InputLabel>
                        <Select
                            labelId="company-select-id-label"
                            name="companyId"
                            defaultValue={defaultValues ? defaultValues.companyId : userCompanyId}
                            input={<OutlinedInput label="Empresa" />}
                            onChange={handleChange}
                            sx={styleBorderField("100%")}
                        >
                            {companies.map(c => {
                                return <MenuItem value={c.id}>{c.name}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        id="rfidTagValue"
                        fullWidth
                        required
                        label="RFID"
                        name="rfidTagValue"
                        variant="outlined"
                        type="number"
                        helperText="Digite apenas números"
                        InputProps={{
                            inputProps: {
                                pattern: '[0-9]*',
                            },
                            sx: {
                                boxShadow: '1px 1px 3px 1px rgb(217, 217, 217)',
                                borderRadius: '6px',
                            },
                        }}
                        FormHelperTextProps={{
                            sx: {
                                boxShadow: '0px 0px 0px 0px rgb(255, 255, 255)',
                            }
                        }}
                        defaultValue={defaultValues ? defaultValues.rfidTagValue : ""}

                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        id="cnhExpirationDate"
                        InputLabelProps={{ shrink: true }}
                        type='date'
                        fullWidth
                        required
                        placeholder=""
                        label="Data Expiração CNH"
                        name="cnhExpirationDate"
                        variant="outlined"
                        defaultValue={defaultValues && defaultValues.cnhExpirationDate ? moment(defaultValues.cnhExpirationDate).format("YYYY-MM-DD") : ""}
                        sx={styleBorderField("100%")}
                    />
                </Grid>
            </Grid>
        </FormLayout >
    );
}